import React from 'react'
import ForHim from '../../../components /ProductPage/ItemsProduct/ForhimProduct'

const ForHimPage = () => {
  return (
    <div>
      <ForHim />
    </div>
  )
}

export default ForHimPage
